import { render, staticRenderFns } from "./primary-pink-button.vue?vue&type=template&id=a3cae498&scoped=true"
import script from "./primary-pink-button.vue?vue&type=script&lang=js"
export * from "./primary-pink-button.vue?vue&type=script&lang=js"
import style0 from "./primary-pink-button.vue?vue&type=style&index=0&id=a3cae498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cae498",
  null
  
)

export default component.exports